.drawer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--tuna-palette-background-paper);
  border-top: 1px solid var(--tuna-palette-divider);
  z-index: 10;
  max-height: 50vh;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 16px;
  border-bottom: 1px solid var(--tuna-palette-divider);
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-lg);
  font-weight: 500;
}

.body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.controls {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.tempoLabel {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--tuna-typography-fontSize-md);
}

.tempoLabel input[type='range'] {
  min-width: 8rem;
  min-height: 44px;
}

.closeButton {
  min-height: 44px;
  min-width: 44px;
}

@media (max-width: 599.95px) {
  .drawer {
    max-height: 75vh;
  }
  .header {
    flex-direction: column;
    align-items: stretch;
  }
  .controls {
    justify-content: space-between;
  }
  .tempoLabel input[type='range'] {
    flex: 1 1 auto;
  }
}
